import { members, samura } from "../../data/samura"

export function GetMembers() {
    return members
}

export function GetSamura() {
    return samura
}